"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M18.445 7.976a.66.66 0 1 1 0 1.32H16.77a.66.66 0 0 1 0-1.32h1.675Z"
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M14.339 1.799a1.7 1.7 0 0 1 1.7 1.7.818.818 0 0 1-1.635-.001.066.066 0 0 0-.065-.065H3.453a.817.817 0 0 0-.816.817v13.043h9.58V7.181c0-.952.723-1.734 1.65-1.828l.01-.001.167-.01h7.129l.167.01h.01l.171.026c.843.167 1.479.91 1.479 1.803v13.191l-.009.168v.01a1.839 1.839 0 0 1-1.641 1.64l-.011.001-.167.008h-7.128l-.166-.008h-.012l-.007-.002c-.053 0-.123.004-.214.004h-2.09c-.006.001-.012.004-.019.004l-.084.004H3.453c-.052 0-.103-.005-.154-.008h-.76c-.85 0-1.539-.73-1.539-1.633v-3.267h.003V4.25a2.451 2.451 0 0 1 2.45-2.451H14.34Zm-.44 5.25a.203.203 0 0 0-.05.132v13.181a.205.205 0 0 0 .205.204h7.11l.04-.003a.206.206 0 0 0 .163-.2V7.18a.205.205 0 0 0-.049-.132H13.9ZM8.25 18.003a.817.817 0 1 0 .001 1.635.817.817 0 0 0-.002-1.635Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};